import { Injectable } from "@angular/core";
import { ApiService } from "../api/api.service";
import { Observable, catchError, from, map, of, throwError } from "rxjs";
import { PdvDescription } from "src/app/models/Pdv/PdvDescription.model";
import { Pdv } from "src/app/models/Pdv/Pdv.model";
import { AlertMessageService } from "../alert-message/alert-message.service";
import { PdvNfce } from "src/app/models/Pdv/PdvNfce.model";
import { ChangeNumerationNfcePdv } from "src/app/models/Pdv/ChangeNumerationNfcePdv.model";

@Injectable({
    providedIn: 'root'
})
export class PdvService {

    constructor(private api: ApiService,
        private alertMessage: AlertMessageService) {
    }

    public getPdv(): Observable<PdvDescription[]> {
        return from(this.api.get<PdvDescription[]>('/v1/pdv/description'))
            .pipe(
                map((pdv) => {
                    if (!pdv || !pdv.success) {
                        throw new Error(pdv != null ? pdv.messageCode + ': ' + pdv.message : "Erro interno")
                    }
                    return pdv.data as PdvDescription[];
                }),
                catchError((error) => {
                    console.error(error);
                    this.alertMessage.alertErrorMessage('Não foi possível obter a lista de PDVs');
                    return of([])
                })
            )
    }

    public getNfcePdv(): Observable<PdvNfce[]> {
        return from(this.api.get<PdvNfce[]>('/v1/pdv/nfce'))
            .pipe(
                map((pdv) => {
                    if (!pdv || !pdv.success) {
                        throw new Error(pdv != null ? pdv.messageCode + ': ' + pdv.message : "Erro interno")
                    }
                    return pdv.data as PdvNfce[];
                }),
                catchError((error) => {
                    console.error(error);
                    this.alertMessage.alertErrorMessage('Não foi possível obter a NFCE dos PDVs');
                    return of([])
                })
            )
    }

    public async getAllPdvs(): Promise<Pdv[]> {
        try {
            const r = await this.api.get<Pdv[]>("/v1/pdv");
            if (r.success)
                return r.data;

            console.error(r.message);
            return [];
        } catch (error) {
            throw (error);
        }
    }

    public async editName(pdvId: number, newName: string): Promise<boolean> {
        try {
            const r = await this.api.post<boolean>("/v1/pdv/change-name", { PdvId: pdvId, NewName: newName });
            return r.success;
        } catch (error) {
            throw (error);
        }
    }

    public async editNfceNumeration(pdvLog: ChangeNumerationNfcePdv): Promise<void> {
        try {
            const r = await this.api.post<void>("/v1/pdv/pdv-change-numeration-log", {PdvId: pdvLog.pdvId, LoginId: pdvLog.loginId, OldNumeration: pdvLog.oldNumeration, NewNumeration: pdvLog.newNumeration});
        } catch (error) {
            throw error;
        }
    }
}